﻿import { DataTablesHelper } from "../../lib/datatables";

class CookiePolicy {
    constructor() {
        DataTablesHelper.CookiePolicy();
    }
}

const init = () => {
    const cookiePolicy = new CookiePolicy();
}

init();
